var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"sso-page"},[_c('section',[_c('h1',[_vm._v("统一账号登录")]),_c('p',[_vm._v("正在前往统一认证，登录后返回当前应用。")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.login}},[_vm._v("前往登录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }